/* ============================================================
   BULKD — cart-drawer stack-reward bar
   Ported from the NZ Supps drawer (updateReward), retargeted:
     NZ  = cart subtotal  -> free shipping at $99
     BULKD = cart ITEM COUNT -> 2 items = 5% off, 4 items = 10% off
             (matching the BULKDSTACK5 / BULKDSTACK10 order-discount
              codes, which carry min-quantity 2 and 4.)

   ⚠ Why this is structured the way it is:
   /cart/change replaces .drawer__inner's ENTIRE innerHTML via the Section
   Rendering API. So:
     - the bar markup is SERVER-RENDERED in snippets/cart-drawer.liquid
       (a JS-injected node would be destroyed on every +/-/remove), and
     - the count is read from data-count (Liquid), never from the
       'cart-update' event payload (which is {source} only, no cart data),
       and never from a /cart.js fetch (which could land out of order).
     - `prevCount` lives in MODULE scope so it survives the innerHTML swap.
       NZ builds its checkpoints once and patches them; here the nodes are
       brand new on every update, so we invert that: rebuild the dots each
       render and decide the once-only "just-hit" pop from prevCount -> n.
   ============================================================ */
(function () {
  'use strict';

  var REWARDS = [
    { qty: 2, label: '5% off',  code: 'BULKDSTACK5'  },
    { qty: 4, label: '10% off', code: 'BULKDSTACK10' }
  ];
  var MAX = REWARDS[REWARDS.length - 1].qty;

  var prevCount = null; // module scope — survives the section swap

  function percentIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
  }

  /* the code that is actually live for a given item count (null = none yet) */
  function codeFor(n) {
    var code = null;
    for (var i = 0; i < REWARDS.length; i++) if (n >= REWARDS[i].qty) code = REWARDS[i].code;
    return code;
  }

  function render() {
    var wrap = document.querySelector('[data-bkd-reward]');
    if (!wrap) return;

    var n = parseInt(wrap.getAttribute('data-count'), 10) || 0;
    if (n <= 0) { wrap.hidden = true; prevCount = n; return; }
    wrap.hidden = false;

    var fill = wrap.querySelector('[data-bkd-reward-fill]');
    var msg  = wrap.querySelector('[data-bkd-reward-msg]');
    var pts  = wrap.querySelector('[data-bkd-reward-pts]');

    var pct = Math.min(n / MAX, 1) * 100;

    /* next unreached tier */
    var next = null;
    for (var i = 0; i < REWARDS.length; i++) { if (n < REWARDS[i].qty) { next = REWARDS[i]; break; } }

    if (msg) {
      if (next) {
        var need = next.qty - n;
        msg.innerHTML = 'Add <b>' + need + '</b> more item' + (need === 1 ? '' : 's') + ' for <b>' + next.label + '</b>';
      } else {
        msg.innerHTML = 'You’ve unlocked <b>' + REWARDS[REWARDS.length - 1].label + '</b>! 🎉';
      }
    }

    /* Rebuild the dots (they're new nodes after every section swap anyway), but
       compute the once-only pop from prevCount -> n so it fires exactly once
       per crossing rather than on every cart update. */
    if (pts) {
      pts.innerHTML = REWARDS.map(function (r) {
        var reached = n >= r.qty;
        var wasReached = prevCount !== null && prevCount >= r.qty;
        var justHit = reached && !wasReached && prevCount !== null;
        var left = Math.min(r.qty / MAX, 1) * 100;
        return '<div class="bkd-cdr__reward-pt' + (reached ? ' is-reached' : '') + (justHit ? ' just-hit' : '') +
               '" style="left:' + left + '%" title="' + r.label + ' at ' + r.qty + ' items">' + percentIcon() + '</div>';
      }).join('');
      if (pts.querySelector('.just-hit')) {
        setTimeout(function () {
          [].forEach.call(pts.querySelectorAll('.just-hit'), function (el) { el.classList.remove('just-hit'); });
        }, 500);
      }
    }

    /* Liquid already server-rendered the correct width, so the bar is right with zero JS.
       To make it ANIMATE on a change, snap back to the old width (transition off), force a
       reflow, then set the target SYNCHRONOUSLY — never inside rAF, which a backgrounded tab
       or a mid-swap frame can strand, leaving the bar stuck at the wrong width. */
    if (fill) {
      var target = pct + '%';
      if (prevCount !== null && prevCount !== n) {
        var from = (Math.min(prevCount / MAX, 1) * 100) + '%';
        fill.style.transition = 'none';
        fill.style.width = from;
        void fill.offsetWidth;          // force reflow so the next set animates
        fill.style.transition = '';     // restore the CSS transition
      }
      fill.style.width = target;        // synchronous — always lands
    }

    prevCount = n;
  }

  /* Checkout must honour what the bar promises: BULKDSTACK5/10 are CODE discounts,
     so apply the right one via /discount/{code} before landing on checkout. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, [name="checkout"]');
    if (!btn) return;
    var wrap = document.querySelector('[data-bkd-reward]');
    if (!wrap) return;
    var n = parseInt(wrap.getAttribute('data-count'), 10) || 0;
    var code = codeFor(n);
    if (!code) return; // below the first tier — normal checkout
    e.preventDefault();
    e.stopPropagation();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout');
  }, true); // capture — beat the form submit

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();

  /* cc-pro (Dawn) publishes 'cart-update' AFTER the section HTML has been swapped in,
     so reading data-count here is safe. Payload carries no cart data — don't rely on it. */
  if (typeof window.subscribe === 'function') window.subscribe('cart-update', function () { render(); });

  /* belt-and-braces: if the pubsub key ever changes, still catch the swap */
  var inner = document.querySelector('cart-drawer .drawer__inner');
  if (inner && window.MutationObserver) {
    new MutationObserver(function () { render(); }).observe(inner, { childList: true });
  }
})();
